import { PageMeta } from 'types/Pages'

export const PageMetaSetting: PageMeta = {
  location: '/company/logistics/new',
  title: 'Cadastrar Logística',
  endpoint: '/app/company',
}
